
<a id="open-volume" href="javascript:;" (click)="open = true">
  <i class="fa fa-volume-off" *ngIf="volume < 0.02" aria-hidden="true"></i> 
  <i class="fa fa-volume-down" *ngIf="volume >= 0.02 && volume <= 0.6" aria-hidden="true"></i>
  <i class="fa fa-volume-up" *ngIf="volume > 0.6" aria-hidden="true"></i>
</a>

<div id="volume-slider" [class.active]="open">
  <div id="volume-slider-track">  
    <div #volumeTrackReceiver id="volume-slider-receiver" 
      (mousedown)="volumeSliderMouseDown($event)"></div>
    <div id="volume-slider-line"></div>
    <div id="volume-slider-button" [style.bottom]="(volume*100)+'%'" 
      (mousedown)="volumeSliderMouseDown($event)">
      <div id="volume-slider-button-visual"></div>
    </div>
  </div>

  <a href="javascript:;" (click)="toggleMute($event)">
    <ng-container *ngIf="muted">
      <i class="fa fa-volume-off muted" *ngIf="volume == 0" aria-hidden="true"></i>
    </ng-container>
    <ng-container *ngIf="!muted">
      <i class="fa fa-volume-off" *ngIf="volume == 0" aria-hidden="true"></i>
      <i class="fa fa-volume-down" *ngIf="volume > 0 && volume <= 0.6" aria-hidden="true"></i>
      <i class="fa fa-volume-up" *ngIf="volume > 0.6" aria-hidden="true"></i>
    </ng-container>
  </a>
</div> 